import React, { useState, useEffect } from 'react';

function SmartImage({
  src,
  alt,
  className,
  fallbackComponent,
  ...props
}) {
  const [error, setError] = useState(false);
  const cleanImageUrl = (url) => {
    if(!url || !url.includes('s120')) {
      return url;
    }
    return `${url.slice(0, url.indexOf('=s120'))}`;
  };

  useEffect(() => {
    setError(false);
  }, [src]);

  if(src && src.length > 0 && !error) {
    return (
      <img
        src={cleanImageUrl(src)}
        alt={alt || 'profile image of user'}
        className={className}
        onError={() => setError(true)}
        referrerPolicy="no-referrer"
        {...props}
      />
    );
  }

  return fallbackComponent || null;
}

export default SmartImage;
